import axios from 'axios';
import { getCookie, setCookie } from '../utils/cookies';
import URL from '../configs/baseUrl';
import COOKIES_STORAGE from '../configs/cookiesStorage';

const { COOKIES } = COOKIES_STORAGE;

const getTokenAuth = () => {
  if (
    getCookie(COOKIES.TOKEN) !== '' &&
    getCookie(COOKIES.TOKEN) !== 'undefined'
  ) {
    return JSON.parse(getCookie(COOKIES.TOKEN));
  }
  return '';
};
const createAxiosInterceptor = (url) => {
  const path = window.location.pathname;
  const axiosCreate = axios.create({
    baseURL: url,
    headers: {
      Accept: 'application/json',
      'Accept-Language': 'es',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getTokenAuth()}`,
    },
  });

  axiosCreate.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      if (error.response.status === 401) {
        setCookie(COOKIES.USER_DATA, '');
        setCookie(COOKIES.TOKEN, '');
        if (path !== URL.LOGIN) window.location.replace(URL.LOGIN);
      }
      return Promise.reject(error.response);
    }
  );

  return axiosCreate;
};

const BaseService = createAxiosInterceptor(process.env.REACT_APP_REST_URL);

export default BaseService;
